import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'src/components/ui/dialog';
import { ChangeProjectNameModalContent } from './ChangeProjectNameModalContent';

export const ChangeProjectNameModal = ({
  disabled = false,
  trigger = <button>Change Project Name</button>,
  project = {},
  setOpenModal = (..._args: any[]) => {},
}) => {
  const [open, setOpen] = useState(false);

  const closePopup = () => {
    setOpen(false);
    setOpenModal(false);
  };

  const onOpenChangeHandler = (open) => {
    setOpenModal(open);
    setOpen(open);
  };

  return (
    <Dialog onOpenChange={onOpenChangeHandler} open={disabled ? false : open}>
      <DialogTrigger disabled={disabled} asChild>
        {trigger}
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="opacity-80 text-lg font-medium font-jamjuree">
            Rename project
          </DialogTitle>
        </DialogHeader>
        <div>
          <ChangeProjectNameModalContent close={closePopup} project={project} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
